import React from "react";
import { usePostUploadState, usePostUploadActions } from "../../contexts/PostUploadContext";
import { useTranslation } from "react-i18next";

const UploadStatus = () => {
    const { uploads } = usePostUploadState();
    const { removeUpload, retryUpload } = usePostUploadActions();
    const { t } = useTranslation();

    const activeUploads = Object.values(uploads);

    if (activeUploads.length === 0) return null;

    return (
        <div
            style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                fontFamily: "var(--font-family, sans-serif)",
            }}
        >
            {activeUploads.map((upload) => (
                <div
                    key={upload.id}
                    style={{
                        background: "white",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        padding: "12px",
                        width: "300px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        animation: "slideIn 0.3s ease-out",
                    }}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontWeight: "600", fontSize: "14px", color: "#333" }}>
                            {upload.status === "uploading" && t("postCreation.uploading", "Uploading Post...")}
                            {upload.status === "completed" && t("postCreation.uploadSuccess", "Post Uploaded!")}
                            {upload.status === "error" && t("postCreation.uploadFailed", "Upload Failed")}
                        </span>
                        <button
                            onClick={() => removeUpload(upload.id)}
                            style={{
                                border: "none",
                                background: "transparent",
                                color: "#999",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "0 4px",
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {upload.status === "uploading" && (
                        <div style={{ width: "100%", height: "4px", background: "#f0f0f0", borderRadius: "2px", overflow: "hidden" }}>
                            <div
                                style={{
                                    width: `${upload.progress}%`,
                                    height: "100%",
                                    background: "#2a8ad2", // Primary blue
                                    transition: "width 0.2s linear",
                                }}
                            />
                        </div>
                    )}

                    {upload.status === "error" && (
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <span style={{ fontSize: "12px", color: "#dc3545" }}>{upload.error}</span>
                            <button
                                onClick={() => retryUpload(upload.id)}
                                style={{
                                    fontSize: "12px",
                                    color: "#2a8ad2",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    cursor: "pointer",
                                    textAlign: "left",
                                    textDecoration: "underline"
                                }}
                            >
                                {t("common.retry", "Retry")}
                            </button>
                        </div>
                    )}

                    {upload.status === "completed" && (
                        <span style={{ fontSize: "12px", color: "#28a745" }}>
                            {t("postCreation.successMessage", "Your post is now live.")}
                        </span>
                    )}
                </div>
            ))}
            <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default UploadStatus;
